// services/workspaceService.js
import workspace from "@/services/workspace";
import { getOrgs } from "@/services/wsOrgService";
import { allowedOrganizations } from "@/utils/workspaceOrganisations";

let allowedOrgsPromise = null;

const getAllowedWorkspaceOrgs = async () => {
  if (!allowedOrgsPromise) {
    allowedOrgsPromise = (async () => {
      const orgs = await getOrgs();
      return await allowedOrganizations(orgs);
    })();
  }
  return allowedOrgsPromise;
};


export const getFilteredWorkspaceData = async (endpoint, orgFieldName = 'organization', params) => {
  try {
    const allowedOrgs = await getAllowedWorkspaceOrgs();
    const allowedOrgIds = new Set(allowedOrgs.map(org => org.id));
    
    const response = await workspace.get(endpoint, params);
    
    return response.data
      .filter(item => allowedOrgIds.has(item[orgFieldName]))
      .map(item => {
        const matchingOrg = allowedOrgs.find(org => org.id === item[orgFieldName]);
        return {
          ...item,
          organization_name: matchingOrg?.name
        };
      });
  } catch (error) {
    console.error(`Error fetching filtered workspace data from ${endpoint}:`, error);
    throw error;
  }
};

// Clear cache on logout or org change
export const clearWorkspaceOrgCache = () => {
  allowedOrgsPromise = null;
};